<template>
  <div>
    <main role="main">
      <div class="content-container">
        <multi-step-form-wrapper
          ref="surveyEmbed"
          :service="'survey-service-login'"
          :accessToken="accessToken"
          @done="finishedSurvey"
          :showSurveyAfter="showSurveyAfter"
          :domain="apiBaseUrl"
          :customSkipFn="skipBtnClicked"
        />
      </div>
    </main>
  </div>
</template>

<script>
const mapState = window.Vuex.mapState;

export default {
  computed: {
    ...mapState({
      accessToken: state => state.auth.accessToken,
      apiBaseUrl: state => state.config.configurationData.apiBaseUrl
    }),
    nextDestination() {
      return this.$route.query.destination
        ? this.$route.query.destination
        : "/";
    }
  },
  data() {
    return {
      showSurveyAfter: true
    };
  },
  mounted() {
    const { fetch: originalFetch } = window;
    window.fetch = async (...args) => {
      let [resource, config] = args;

      let response = await originalFetch(resource, config);

      if (resource.includes("/api/internet/survey/v1/submission/create")) {
        this.$store.commit("survey/setHasFilledSurvey", true);
        window.location.href = String("/aceas" + this.nextDestination);
        return response;
      }

      return response;
    };

    this.$watch(
      () => {
        return this.$refs.surveyEmbed.$children[0].isMandatory;
      },
      val => {
        this.$store.commit("survey/setIsSurveyMandatory", val);
      }
    );
  },
  methods: {
    finishedSurvey() {
      this.$store.commit("survey/setHasFilledSurvey", true);
      setTimeout(() => {
        window.location.href = String("/aceas" + this.nextDestination);
      }, 100);
    }
  }
};
</script>

<style></style>
